import Lottie from 'lottie-react';
import React from 'react';
import loader from './assets/mobiworkx-loader.json';

export interface Props {
  width?: number;
  height?: number;
  className?: string;
}

const LoadingIndicator: React.FC<Props> = ({ width = 150, height = 150, className }: Props) => {
  return (
    <Lottie
      className={className}
      style={{ width: `${width}px`, height: `${height}px` }}
      animationData={loader}
      data-chromatic="ignore"
    />
  );
};

export default LoadingIndicator;
